// imports
import { Observable } from "rxjs";
import { ConfigService } from "@ng-darwin/config";
import { HttpClient } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { LogService } from "./log.service";
import { map } from "rxjs/operators";

/**
 * interfaz con los
 * datos de respuesta del login
 */
export interface ILoginResponse {
  locator: string;
  isFirstTime: boolean;
  correctLogin: boolean;
}

@Injectable({
  providedIn: "root",
})
export class LoginService extends LogService {
  static signIn: (encryptedPIN: any, sortUrl: any) => any;
  public xClientid = "X-Clientid";
  // constructor
  constructor(
    public http: HttpClient,
    injector: Injector,
    public config: ConfigService
  ) {
    super(http, injector, config);
  }
  /**
   * metodo que ingresa
   * el usuario
   * la contraseña
   * y un booleano para recordar la contraseña
   */
  signIn(body: {
    user: string;
    pass: string;
    remember: boolean;
  }): Observable<ILoginResponse> {
    this.httpHeaders = this.httpHeaders.set(
      this.xClientid,
      this.config.config.appKey
    );
    this.url = this.endPoints.login;
    this.httpClientMethod = this.getBareClient();
    return this.create(body);
  }

  obtainBackgroundImage() : Observable<any> {
    this.url = this.endPoints.loginWallpaper;
    this.httpClientMethod = this.http;
    return this.getData();
  }


  getOficinas(): Observable<any> {
    this.url = this.endPoints.ordinales;
    this.httpClientMethod = this.http;
    return this.getData();
  }

  resetPass(body: { user: string; reset: boolean }): Observable<any> {
    this.httpHeaders = this.httpHeaders.set(
      this.xClientid,
      this.config.config.appKey
    );
    this.url = this.endPoints.login;
    this.httpClientMethod = this.getBareClient();
    return this.reset(body);
  }

  getProfile(uid: string): Observable<any>{
    this.httpClientMethod = this.http;
    this.url = this.endPoints.perfilPrescriptor;
    this.params = this.params.set("documento", uid);

    return this.getData();
  }

  changePass(body: {
    user: string;
    pass: string;
    newPass: string;
    confirmNewPass: string;
    reset: boolean;
  }): Observable<any> {
    this.httpHeaders = this.httpHeaders.set(
      this.xClientid,
      this.config.config.appKey
    );
    this.url = this.endPoints.login;
    this.httpClientMethod = this.getBareClient();
    return this.reset(body);
  }

  /**
   * Seteo en session storage de oficinas
   */
  setStorageOficinas(oficinas: string) {
    this.setStorage("oficinas", oficinas);
  }
}
